import styled from 'styled-components';
import { mq } from '../../../stylesheets/tools';

const spinnerHeightMobile = '15px';
const spinnerHeightDesktop = '30px';

const StyledLoadingIndicator = styled.div`
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  width: ${spinnerHeightDesktop};

  .loadingIndicator__spinner {
    animation-duration: 0.9s;
    animation-iteration-count: infinite;
    animation-name: rotate;
    animation-timing-function: linear;
    height: ${spinnerHeightMobile};
    width: ${spinnerHeightMobile};
    border: 1px solid ${props => (props.inverted ? '#000' : '#fff')};
    border-right-color: transparent;
    border-radius: 50%;
    display: inline-block;
  }

  ${mq('m')} {
    width: ${spinnerHeightDesktop};

    .loadingIndicator__spinner {
      height: ${spinnerHeightDesktop};
      width: ${spinnerHeightDesktop};
      border-width: 3px;
    }
  }
`;

export default StyledLoadingIndicator;
